import React from "react";
import SideBarSkeleton from "../../Components/atoms/SideBarSkeleton";
import { ArticlesCardMain } from "../../Components/molecules/BlogCard";
import cardimg from "../../assets/images/dummy-images/blog.png";

const BlogDetail = () => {
  const blogData = {
    image: cardimg,
    title: "Sample Blog Title",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    date: "December 31, 2024",
  };

  return (
    <SideBarSkeleton>
      <div>
        <ArticlesCardMain data={blogData} />
      </div>
    </SideBarSkeleton>
  );
};

export default BlogDetail;
